import { Component,  Input, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormControl } from '@angular/forms';
import { preventDuplication } from '@shared/validators/prevent-duplication.validator';
import { BaseComponent } from '@shared/components/base-component/base.component';
import { CustomerType } from "@shared/enums/customer-type.enum";
import { ReceiverType } from "@shared-features/enums/receiver-type.enum";
import { ReceiversCommonApiService } from '@shared-features/services/receivers-common-api';
import { of, zip } from 'rxjs';
import { requiredKeys } from '@shared/validators/required-keys.validator';
import { takeUntil } from 'rxjs/operators';
import { Receiver } from '@features/receivers/models/receiver';

@Component({
  selector: 'app-permit-access-control-list',
  templateUrl: './permit-access-control-list.component.html',
  styleUrls: ['./permit-access-control-list.component.scss']
})
export class PermitAccessControlListComponent extends BaseComponent implements OnInit {
  @Input() formArray: UntypedFormArray;
  @Input() customerId: number;
  @Input() customerType: CustomerType;
  receivers: Receiver[];

  validatorsPerControl: {[k: number]: boolean} = {};

  constructor( private receiversCommonApiService: ReceiversCommonApiService) {
    super();
  }

  ngOnInit(): void {
    const shouldGetGlobal = this.customerType === CustomerType.Service || !this.customerId;
    const shouldGetPerCustomer = this.customerType === CustomerType.Saas && this.customerId;

    this.load(
      zip(
        shouldGetGlobal
          ? this.receiversCommonApiService.getAllReceivers(ReceiverType.General, null)
          : of([]),
        shouldGetPerCustomer
          ? this.receiversCommonApiService.getAllReceivers(ReceiverType.Customer, this.customerId)
          : of([])
      )
    ).subscribe(([general, customer]) => {
      this.receivers = [...general, ...customer];
    });

    if (!this.formArray.controls?.length) {
      this.addAnotherControl();
    }
  }

  addAnotherControl(): void {
    const validators = [
      requiredKeys(['receiver', 'expirationDate', 'label']),
      preventDuplication(this.formArray, this.formArray.controls.length, ['receiver', 'expirationDate']),
    ];

    const control = new UntypedFormControl({ label: null, receiver: null, expirationDate: null }, []);
    const controlIndex = this.formArray.controls.length;

    control.valueChanges.pipe(
      takeUntil(this.destroy$),
    ).subscribe(() => {
      const hasValue = Object.keys(control.value).some(key => control.value[key] !== null && typeof control.value[key] !== 'undefined');
      if (hasValue && !this.validatorsPerControl[controlIndex]) {
        control.setValidators(validators);
        this.validatorsPerControl[controlIndex] = true;
        control.updateValueAndValidity();
      } else if (this.validatorsPerControl[controlIndex]) {
        control.setValidators([]);
        this.validatorsPerControl[controlIndex] = false;
        // control.updateValueAndValidity({ onlySelf: true, emitEvent: false });
      }
    });

    this.formArray.push(control);
    this.formArray.updateValueAndValidity();
  }

  removeControl(index: number): void {
    this.formArray.removeAt(index);
    this.formArray.updateValueAndValidity();
    this.validatorsPerControl[index] = false;
  }
}
